import { ProductPackage } from '../settings';

export const toPrice = (p?: number) => (p ?? 0)/100;

export const displayPrice = (p?: number, suffix = 'zł', fractionDigits = 2) => `${toPrice(p).toFixed(fractionDigits)} ${suffix}`

export const getPackage = (packages: ProductPackage[], packageName: string) =>  packages.find((p) => p.name === packageName);
export const getPackagePrice = (packages: ProductPackage[], packageName: string) =>  getPackage(packages, packageName)?.value || 0;
